// extracted by mini-css-extract-plugin
module.exports = {"list":"item-list_list_24y1l","arrow":"item-list_arrow_1dMDk","arrow-up":"item-list_arrow-up_3vsZc"};